<template>
    <div>
        <ts-page-title
            :title="$t('monitoringSurvey.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('monitoringSurvey.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="card border-0 bg-gray-900">
                            <div class="card-body">
                                <div class="text-gray-500">
                                    <b>{{
                                        $t("monitoringSurvey.filterCriteria")
                                    }}</b>
                                </div>
                            </div>
                            <div class="widget-list rounded-bottom">
                                <div class="mb-3 mt-3">
                                    <div class="col-md-12">
                                        <label
                                            class="form-col-label control-label"
                                            >{{
                                                $t("accountUnpaid.branch")
                                            }}</label
                                        >
                                        <ts-branch-filter
                                            @filter="
                                                value =>
                                                    (model.branch_id = value)
                                            "
                                            :isPlaceholder="true"
                                        />
                                        <div
                                            class="text-danger"
                                            v-if="errors.has('branch_id')"
                                        >
                                            {{ errors.first("branch_id") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="col-md-12">
                                        <label
                                            class="form-col-label control-label"
                                            >{{
                                                $t(
                                                    "monitoringSurvey.surveyDate"
                                                )
                                            }}</label
                                        >
                                        <DatePicker
                                            v-model="model.dateRange"
                                            type="daterange"
                                            placement="bottom-end"
                                            :placeholder="$t('selectDateRange')"
                                            style="width: 100%"
                                            :transfer="true"
                                            format="dd-MM-yyyy"
                                            @on-change="onChangeSurveyDate"
                                        ></DatePicker>
                                        <div
                                            class="text-danger"
                                            v-if="errors.has('dateRange')"
                                        >
                                            {{ errors.first("dateRange") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label
                                        class="form-col-label control-label required"
                                        >{{
                                            $t(
                                                "monitoringSurvey.questionCategory"
                                            )
                                        }}</label
                                    >
                                    <Select
                                        v-model="model.question_cat_id"
                                        :filterable="true"
                                        :filter-by-label="true"
                                        :placeholder="$t('Select')"
                                        :clearable="true"
                                    >
                                        <Option
                                            v-for="item in questionCategories"
                                            :value="item.question_cat_id"
                                            :key="item.question_cat_id"
                                            :label="item.question_cat_name_en"
                                        >
                                            {{ item.question_cat_name_en }}
                                        </Option>
                                    </Select>
                                    <div
                                        class="text-danger"
                                        v-if="errors.has('question_cat_id')"
                                    >
                                        {{ errors.first("question_cat_id") }}
                                    </div>
                                </div>
                                <div
                                    class="mb-3 tw-justify-end tw-flex tw-space-x-2"
                                >
                                    <ts-button
                                        outline
                                        color="success"
                                        @click.prevent="exportExcel"
                                        :waiting="exporting"
                                    >
                                        <i
                                            class="far fa-file-excel"
                                            v-if="!exporting"
                                        ></i>
                                        {{ $t("exportExcel") }}</ts-button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-9">
                        <div id="container">
                            <ts-preview-pdf v-model="waiting" :src="src" />
                        </div>
                    </div>
                </div>
            </ts-panel-wrapper>
        </ts-panel>
    </div>
</template>
<script>
import { Errors } from "form-backend-validation";
import * as FileDownload from "downloadjs";
import { trim } from "lodash";
import moment from "moment";
import { mapState } from "vuex/dist/vuex.common.js";
import { mapActions } from "vuex/dist/vuex.common.js";
export default {
    name: "accountUnpaid",
    data() {
        return {
            waiting: false,
            exporting: false,
            errors: new Errors(),
            src: "",
            model: {
                question_cat_id: null,
                branch_id: [],
                dateRange: [
                    moment()
                        .startOf("month")
                        .format("DD-MM-YYYY"),
                    moment()
                        .endOf("month")
                        .format("DD-MM-YYYY")
                ]
            }
        };
    },
    created() {
        this.getQuestionCategory();
    },
    computed: {
        ...mapState("creditOperation/monitoringQuestion", [
            "questionCategories"
        ])
    },
    methods: {
        ...mapActions("creditOperation/monitoringQuestion", [
            "getQuestionCategory"
        ]),
        exportExcel() {
            this.errors = new Errors();
            this.exporting = true;

            this.$store
                .dispatch(
                    "report/creditOperation/monitoringSurveyExportExcel",
                    this.model
                )
                .then(response => {
                    let filename = trim(
                        response.headers["content-disposition"]
                            .substring(
                                response.headers["content-disposition"].indexOf(
                                    "filename"
                                )
                            )
                            .replace("filename=", ""),
                        '"'
                    );
                    if(filename == '1.xlsx')
                    {
                        filename = 'ត្រួតពិនិត្យការប្រមូលរបស់មន្រ្តីផ្នែកលក់.xlsx';
                    }
                    if(filename == '2.xlsx')
                    {
                        filename = 'ត្រួតពិនិត្យប្រធានផ្នែកលក់.xlsx';
                    }
                    if(filename == '3.xlsx')
                    {
                        filename = 'ត្រួតពិនិត្យឯកសារទំលាក់ទុនប្រធានផ្នែកលក់.xlsx';
                    }
                    FileDownload(response.data, filename);
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    );
                    this.notice({ type: "error", text: error.message });
                    this.errors = new Errors(error.errors);
                })
                .finally(() => (this.exporting = false));
        },
        onChangeSurveyDate(dateRange) {
            this.model.dateRange =
                dateRange[0] && dateRange[1] ? dateRange : [];
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "MONITORING SURVEY",
                desc: not.text
            });
        }
    }
};
</script>
